import { render } from "./MenuItem.vue?vue&type=template&id=f9e6461c&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=f9e6461c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9e6461c"

export default script